import {createAction, props} from "@ngrx/store";
import {Serializer} from "../../interfaces/serializer";
import {Notification} from "../../interfaces/notification";

export const notificationMarkAsRead = createAction('[Notification] Mark as read', props<{ notification: Serializer<Notification> }>());
export const notificationMarkAsReadSuccess = createAction('[Notification] Mark as read success', props<{ notification: Serializer<Notification> }>());
export const notificationMarkAsReadFailure = createAction('[Notification] Mark as read failure', props<{ notification: Serializer<Notification> }>());
